import { render } from "./SalesReturnView.vue?vue&type=template&id=179d2d9e"
import script from "./SalesReturnView.vue?vue&type=script&lang=js"
export * from "./SalesReturnView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__